import imgParkingIllustration from "../../assets/new_ui_img/parking_illustration.svg";

export default function ParkingIllustration() {
  return (
    <div className="relative w-full flex items-center justify-center">
      <img
        src={imgParkingIllustration}
        alt="Parking Map Illustration"
        className="w-full h-auto max-w-full object-contain select-none pointer-events-none"
        loading="lazy"
      />
    </div>
  );
}
